import { render, staticRenderFns } from "./editRemark.vue?vue&type=template&id=5ba08df9&scoped=true"
import script from "./editRemark.vue?vue&type=script&lang=js"
export * from "./editRemark.vue?vue&type=script&lang=js"
import style0 from "./editRemark.vue?vue&type=style&index=0&id=5ba08df9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba08df9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba08df9')) {
      api.createRecord('5ba08df9', component.options)
    } else {
      api.reload('5ba08df9', component.options)
    }
    module.hot.accept("./editRemark.vue?vue&type=template&id=5ba08df9&scoped=true", function () {
      api.rerender('5ba08df9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/customPrintNewReconsitution/components/editRemark.vue"
export default component.exports